import moment from 'moment'

export const getMonths = (): string[] =>
  Array.from({ length: 12 }, (_, index) => moment().month(index).format('MMMM'))

export const generateYears = (
  showPastOnly?: boolean,
  showFutureOnly?: boolean
): string[] => {
  const currentYear = moment().year()
  const startYear = 1912
  const endYear = showPastOnly ? currentYear : currentYear + 15
  const yearsLength = endYear - startYear + 1

  const allYears = Array.from({ length: yearsLength }, (_, index) => {
    const year = startYear + index
    if (showPastOnly && year > currentYear) return null
    if (showFutureOnly && year < currentYear) return null
    return String(year)
  }).filter(Boolean) as string[]

  const sortedYears = allYears.sort((a, b) => Number(b) - Number(a))

  return sortedYears
}

export const generateDays = (month: number, year: string): string[] => {
  const daysInMonth = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()
  const days = Array.from({ length: daysInMonth }, (_, index) =>
    String(index + 1)
  )
  return days
}

export const generateHours = () => {
  return Array.from({ length: 12 }, (_, index) => {
    const hour = index + 1
    return String(hour).padStart(2, '0')
  })
}

export const generateMinutes = () => {
  return Array.from({ length: 60 }, (_, index) => {
    return String(index).padStart(2, '0')
  })
}

export const timeFormats = ['AM', 'PM']
